import { createStyles } from "@material-ui/core";

export default createStyles({

  hidden: {
    display: "none"
  },

  visible: {
    display: "flex",
    width: "100%",
    height: "100%"
  },

  mediaContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  },

  image: {
    maxWidth: "100%",
    maxHeight: "100%"
  },

  video: {
    width: "100%",
    height: "100%"
  }

});